var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerChargingStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#00BB00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.08-310.77v-135.38h-67.7l101.54-203.08v135.38h67.7L463.08-310.77ZM304.62-80Q277-80 258.5-98.5 240-117 240-144.62v-670.76q0-27.62 18.5-46.12Q277-880 304.62-880h350.76q27.62 0 46.12 18.5Q720-843 720-815.38v670.76q0 27.62-18.5 46.12Q683-80 655.38-80H304.62ZM280-180v35.38q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h350.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93V-180H280Zm0-40h400v-520H280v520Zm0-560h400v-35.38q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H304.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93V-780Zm0 0v-60 60Zm0 600v60-60Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerChargingStationIcon);
export default __webpack_public_path__ + "static/media/marker-charging-station-icon.13a8797f616c06b12c095be0b5cfba70.svg";
export { ForwardRef as ReactComponent };